import PaymentFrequency from './PaymentFrequency';

export default PaymentFrequency;
